/** Trigger a browser file download from blob/binary API response data. */
export function triggerBlobDownload(data, filename, mimeType) {
  const blob = mimeType ? new Blob([data], { type: mimeType }) : new Blob([data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || 'download';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

const STORAGE_PREFIX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_[0-9a-f]{8}_/i;

function fileExtension(filename) {
  const parts = String(filename || '').split('.');
  if (parts.length < 2) return 'pdf';
  const ext = parts.pop().toLowerCase();
  return /^[a-z0-9]{2,5}$/.test(ext) ? ext : 'pdf';
}

function safePersonFileName(personName) {
  return String(personName || '')
    .trim()
    .replace(/[<>:"/\\|?*]+/g, '')
    .replace(/\s+/g, ' ')
    .slice(0, 80);
}

/** Derive a human filename from a stored resume URL or path (strips user-id prefix). */
export function resumeFileNameFromUrl(resumeUrl) {
  if (!resumeUrl) return 'resume.pdf';
  const path = String(resumeUrl).split('?')[0];
  let name = path.split('/').pop() || '';
  name = name.replace(STORAGE_PREFIX, '');
  return name || 'resume.pdf';
}

/** Label for UI/download: "{Name} Resume.pdf" when a person name is known. */
export function resumeDisplayName(resumeUrl, personName) {
  const stored = resumeFileNameFromUrl(resumeUrl);
  const ext = fileExtension(stored);
  const safe = safePersonFileName(personName);
  if (safe) return `${safe} Resume.${ext}`;
  return stored;
}
